import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
    ApplicationConfig,
    importProvidersFrom
} from '@angular/core';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';
import { IconsModule } from '@core/utils/icons.module';
import { provideFuse } from '@fuse';
import { appRoutes } from 'app/app.routes';
import { provideAuth as FuseProvideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { MockApiService } from 'app/mock-api';
import { environment } from 'environments/environment';
import { provideMarkdown } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
    providers: [
        
        // Additional
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideAuth(() => getAuth()),
        { provide: FIREBASE_OPTIONS, useValue: environment.firebase },

        provideHttpClient(),
        provideMarkdown({ loader: HttpClient }),
        importProvidersFrom(IconsModule),
        // Initial
        provideAnimations(),
        provideHttpClient(withFetch(), withInterceptors([loadingInterceptor]),),
        provideRouter(
            appRoutes,
            withComponentInputBinding(),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
        ),

        // Material Date Adapter
        {
            provide: DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'D',
                },
                display: {
                    dateInput: 'DDD',
                    monthYearLabel: 'LLL yyyy',
                    dateA11yLabel: 'DD',
                    monthYearA11yLabel: 'LLLL yyyy',
                },
            },
        },

        // Transloco Config
        // provideTransloco({
        //     config: {
        //         availableLangs: [
        //             {
        //                 id: 'en',
        //                 label: 'English',
        //             },
        //             {
        //                 id: 'tr',
        //                 label: 'Turkish',
        //             },
        //         ],
        //         defaultLang: 'en',
        //         fallbackLang: 'en',
        //         reRenderOnLangChange: true,
        //         prodMode: !isDevMode(),
        //     },
        //     loader: TranslocoHttpLoader,
        // }),
        // provideAppInitializer(() => {
        //     const translocoService = inject(TranslocoService);
        //     const defaultLang = translocoService.getDefaultLang();
        //     translocoService.setActiveLang(defaultLang);

        //     return firstValueFrom(translocoService.load(defaultLang));
        // }),

        // Fuse
        FuseProvideAuth(),
        provideIcons(),
        provideFuse({
            mockApi: {
                delay: 0,
                service: MockApiService,
            },
            fuse: {
                layout: 'classy',
                scheme: 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme: 'theme-default',
                themes: [
                    {
                        id: 'theme-default',
                        name: 'Default',
                    },
                    {
                        id: 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id: 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id: 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id: 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id: 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),

    ],
};
